export enum ProductServiceTypeEnum {
  FIXED_INTERNET = 'FIXED_INTERNET',
  DTV = 'DTV',
  FIXED_CALLING = 'FIXED_CALLING',
  MOBILE_CALLING = 'MOBILE_CALLING',
  MOBILE_INTERNET = 'MOBILE_INTERNET',
}
